var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner-row" },
    [
      _c(
        "div",
        { staticClass: "accounting-document-form", style: _vm.formWidth },
        [
          _c("div", { staticClass: "accounting-document-form-title" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-select",
                  {
                    ref: "fpSelect",
                    staticStyle: { width: "110px", "margin-right": "5px" },
                    attrs: { no: "1", disabled: _vm.fpSelectDisabled },
                    on: { change: _vm.fiscalPeriodChangeHandler },
                    model: {
                      value: _vm.fiscalPeriodUuid,
                      callback: function($$v) {
                        _vm.fiscalPeriodUuid = $$v
                      },
                      expression: "fiscalPeriodUuid"
                    }
                  },
                  _vm._l(_vm.fpSelectDataProvider, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.fiscalPeriodLabelFun(item),
                        value: item.uuid
                      }
                    })
                  }),
                  1
                ),
                _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Date")) + " "),
                _c("el-date-picker", {
                  ref: "documentDateDF",
                  staticStyle: { width: "130px", "margin-right": "5px" },
                  attrs: {
                    no: "2",
                    type: "date",
                    "value-format": "yyyy-MM-dd"
                  },
                  model: {
                    value: _vm.voucher.documentDate,
                    callback: function($$v) {
                      _vm.$set(_vm.voucher, "documentDate", $$v)
                    },
                    expression: "voucher.documentDate"
                  }
                }),
                _vm._v(
                  " " + _vm._s(_vm.$t("CargoMsg.Cargo_VoucherLetter")) + " "
                ),
                !_vm.voucher.isZhuan
                  ? _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px", "margin-right": "5px" },
                        attrs: { no: "3" },
                        model: {
                          value: _vm.voucher.prefix,
                          callback: function($$v) {
                            _vm.$set(_vm.voucher, "prefix", $$v)
                          },
                          expression: "voucher.prefix"
                        }
                      },
                      _vm._l(_vm.prefixDDL, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.voucher.isZhuan
                  ? _c("el-input", {
                      staticStyle: { width: "55px" },
                      attrs: { no: "4" },
                      model: {
                        value: _vm.voucher.prefix,
                        callback: function($$v) {
                          _vm.$set(_vm.voucher, "prefix", $$v)
                        },
                        expression: "voucher.prefix"
                      }
                    })
                  : _vm._e(),
                _c("el-input", {
                  staticStyle: { width: "55px" },
                  attrs: { no: "5" },
                  model: {
                    value: _vm.voucher.documentNo,
                    callback: function($$v) {
                      _vm.$set(_vm.voucher, "documentNo", $$v)
                    },
                    expression: "voucher.documentNo"
                  }
                }),
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NumberS")) + " ")
              ],
              1
            ),
            _c("div", { staticClass: "center" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BookKeepingVoucher")))
            ]),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("CargoMsg.Cargo_AttachedDocuments")) + " "
                ),
                _c("el-input-number", {
                  staticStyle: { width: "55px" },
                  attrs: { no: "6", controls: false },
                  model: {
                    value: _vm.voucher.sourceDocument,
                    callback: function($$v) {
                      _vm.$set(_vm.voucher, "sourceDocument", $$v)
                    },
                    expression: "voucher.sourceDocument"
                  }
                }),
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Page")) + " ")
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "accounting-document-form-table" },
            [
              _c("accounting-document-grid", {
                ref: "grid",
                attrs: {
                  type: _vm.type,
                  "row-data": _vm.voucher.accountingEntry,
                  "account-set": _vm.accountSet,
                  "fiscal-period": _vm.voucherFiscalPeriod
                },
                on: { changeWidth: _vm.changeWidthHandler }
              })
            ],
            1
          ),
          _c("div", { staticClass: "accounting-document-form-footer" }, [
            _vm.voucherList && _vm.type !== "copy"
              ? _c(
                  "div",
                  { staticClass: "accounting-document-form-footer-button" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "7", type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.changeVoucherIndex(0)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_1St")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "8", type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.changeVoucherIndex(
                              _vm.curVoucherIndex - 1
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TheLastPage")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "9", type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.changeVoucherIndex(
                              _vm.curVoucherIndex + 1
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TheNextPage")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "10", size: "mini", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.changeVoucherIndex(
                              _vm.voucherList.length - 1
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TheLast")))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("CargoMsg.Cargo_PreparedByP")) +
                  _vm._s(_vm.documentMakerStr)
              )
            ]),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.voucher.dateModified,
                    expression: "voucher.dateModified"
                  }
                ]
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_LastModificationTime")) +
                    _vm._s(_vm.voucher.dateModified)
                )
              ]
            ),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.voucher.dateModified,
                  expression: "!voucher.dateModified"
                }
              ]
            })
          ])
        ]
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: this
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }